import { useEffect } from "react";
import { ModeKey } from "./modes";

export const useModeSync = (mode: ModeKey | null) => {
  useEffect(() => {
    console.log(`Syncing external systems for mode: ${mode}`);
    // Example: call API, adjust websocket subscriptions, etc.
  }, [mode]);
};
